// TOUR-2 — permission gate before pulsing a gated control.

import type { AuthContextValue } from "@/contexts/AuthContext";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import { getFireflyTargetDefinition } from "./fireflyTargetRegistry";

export type CanAccessPrimaryModeFn = (
  mode: PrimaryMode,
  auth: AuthContextValue,
) => boolean;

export type FireflyTargetHighlightGateResult =
  | { allowed: true }
  | { allowed: false; reason: "denied_mode"; requiredMode: PrimaryMode };

export function canHighlightFireflyTarget(input: {
  targetId: string;
  auth: AuthContextValue;
  canAccessPrimaryMode: CanAccessPrimaryModeFn;
}): FireflyTargetHighlightGateResult {
  const def = getFireflyTargetDefinition(input.targetId);
  if (!def?.requiredMode) return { allowed: true };
  if (input.canAccessPrimaryMode(def.requiredMode, input.auth)) {
    return { allowed: true };
  }
  return { allowed: false, reason: "denied_mode", requiredMode: def.requiredMode };
}
